export const FETCH_GOOGLE_AUTH_SUCCESS = 'FETCH_GOOGLE_AUTH_SUCCESS'
export const FETCH_GOOGLE_DATA_SUCCESS = 'FETCH_GOOGLE_DATA_SUCCESS'
